<template>
  <div>
    <template v-if="type == 'bar'">
      <bar-chart :myDataset="dataPoints" :options="options" :color="color"
                 :height="barChartSize.height" :width="barChartSize.width"/>
    </template>

    <template v-if="type == 'bar-vertical'">
      <bar-chart-vertical :myDataset="dataPoints" :options="options" :color="color"
                          :height="barChartSize.height" :width="barChartSize.width"/>
    </template>

    <div class="pie-chart__wrapper" :class="hasLegend" v-if="type == 'pie'">
      <div class="pie-chart__container">
        <div class="main-title" v-if="dataPoints.title">
          <h1>{{dataPoints.title.value}}</h1>
          <label>{{dataPoints.title.label}}</label>
        </div>
        <pie-chart :myDataset="dataPoints" :options="options" :color="color"
                   :height="pieChartSize.height" :width="pieChartSize.width"
                   :showTooltip="!!dataPoints.labels"
                   @legend="setLegend"/>
      </div>
      <div class="pie-chart__legend"
           v-if="dataPoints.labels" v-html="htmlLegend"></div>
      <div class="pie-chart__footnote" v-if="dataPoints.footnote">
        <label>{{dataPoints.footnote.label}}</label>
        <h4>{{dataPoints.footnote.value}}</h4>
      </div>
    </div>

  </div>
</template>

<script>
  import PieChart from './chart--pie'
  import BarChart from './chart--bar-horizontal'
  import BarChartVertical from './chart--bar-vertical'

  export default {
    name: "pogs-chart",
    props: {
      'type'       : String,
      'dataPoints' : Object,
      'options'    : Object,
      'size'       : Object
    },
    components: {PieChart, BarChart, BarChartVertical},
    computed:{
      color(){
        return this.dataPoints.color ? this.dataPoints.color : undefined;
      },
      hasLegend(){
        return this.dataPoints.labels ? 'with-legend' : '';
      },
    },
    methods:{
      setLegend(val){
        this.htmlLegend = val;
      }
    },
    data(){
      return{
        barChartSize  : {height: 160, width: 300},
        pieChartSize  : {height: 150, width: 150},
        htmlLegend : null
      }
    },
    mounted(){
      if(this.size != undefined){
        switch(this.type){
          case 'pie':
            this.pieChartSize = this.size;
            break;
          default:
            this.barChartSize = this.size;
            break;
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../../scaffolding/scss/pogs-util";

  .pie-chart__wrapper{
    @extend %flex-col--center-xy;

    &.with-legend{
      @include make-grid-cols(140px auto, space(xl));
      align-items: flex-start;

      .pie-chart__footnote{
        grid-column: span 2;
      }
    }
  }

  .pie-chart__container{
    position: relative;
    z-index: 100;
  }

  .main-title{
    @extend %independent-layout, %flex-col--center-xy;
    pointer-events: none;
    z-index: 99;

    h1{
      font-size: 38px;
    }
  }

  .pie-chart__legend{
    padding-top: space(m);

    & > ul{
      padding: 0;
      list-style: none !important;
      font-size: font(s);

      li{
        @extend %flex-row--center-x;
        padding-bottom: space(s);

        span{
          @extend %border-radius-small;
          display: inline-block;
          width: 15px;
          height: 15px;
          margin-right: space(s);
        }
      }
    }
  }

  .pie-chart__footnote{
    @extend %flex, %align-items-baseline, %justify-content-flex-end;
    @include space-me($t: xs, $r:m, $l: m);
    width: 100%;

    label{
      font-size: font(xs);
      color: color(light);

      & + h4{
        margin-left: space(s);
      }
    }

    h4{
      font-size: font(m);
    }
  }

</style>